
import React from "react";
import { useUser } from "@/hooks/use-user";
import { Navigation } from "@/components/Navigation";
import { Sidebar } from "@/components/Sidebar";
import { MobileNavigation } from "@/components/MobileNavigation";
import { Footer } from "@/components/Footer";
import { useIsMobile } from "@/hooks/use-mobile";

export default function Collabs() {
  const { user, isLoading } = useUser();
  const isMobile = useIsMobile();
  
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <div className="hidden sm:block">
        <Sidebar />
      </div>
      <main className={`${isMobile ? 'pt-16 pb-20' : 'sm:pl-16 pt-20 pl-4 pb-16'} pt-20 pl-4 transition-all duration-300`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-3xl font-extrabold tracking-tight text-primary sm:text-4xl">
              Colaborações
            </h1>
            <p className="mt-3 max-w-2xl mx-auto text-xl text-muted-foreground sm:mt-4">
              Encontre artistas e criadores para colaborar em seus projetos
            </p>
          </div>
          
          <div className="mt-12 bg-card rounded-lg shadow-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Página em desenvolvimento</h2>
            <p className="text-muted-foreground">
              A funcionalidade de colaborações será implementada em breve. Fique ligado para novidades!
            </p>
          </div>
        </div>
      </main>
      <Footer />
      {isMobile && <MobileNavigation />}
    </div>
  );
}
